.cg{aspect-ratio:1/1;}